import { Paper, Title, Text, Button } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import buttonClasses from "../../styles/buttons.module.css";

const TimeForAdvicePaper = ({ message }: { message: string }) => {
  return (
    <Paper
      bg={"var(--wallet-color-masterbrand-accent-yellow)"}
      p={"lg"}
      radius={"lg"}
    >
      <Title
        c={"var(--wallet-color-neutrals-black)"}
        order={4}
        ff={"var(--wallet-font-family-sambla-sans)"}
        mb={"lg"}
      >
        {message}
      </Title>
      <Text>
        Vi har nu allt vi behöver för att kunna rådge dig om din pension.
        Rådgivaren kommer gå igenom igenom hur du kan förbättra ditt
        pensionssparande. Vänligen gå vidare för att se din pensionsprognos i
        mötet med din rådgivare.
      </Text>
      <Button
        variant="default"
        className={buttonClasses.borderBottomOnly}
        component={Link}
        fullWidth
        mt={"lg"}
        to={"/pension-overview"}
      >
        Till Rådgivning
      </Button>
    </Paper>
  );
};

export default TimeForAdvicePaper;
